<template>
    <div>
        <q-tabs two-lines inverted align="center">
            <q-route-tab
                v-for="menu in userMenu"
                v-if='menu.name !== "calendar"'
                :key="menu.name"
                slot="title"
                :to="menu.slug"
                :icon="menu.icon"
                :label="$T(menu.name)"
            />
        </q-tabs>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {
        QTabs,
        QRouteTab
    } from 'quasar-framework'

    export default {
        components: {
            QTabs,
            QRouteTab
        },

        computed: {
            ...mapGetters({
                userMenu: 'userMenu/userMenu'
            }),
            menus() {
                return window.config.menus
            },

            devFolder() {
                return window.config.devAssetsFolder
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Footer.vue